import { connect } from 'react-redux'
import { State } from 'interfaces/state'
import InternalLayout, { InternalLayoutStateProps, InternalLayoutDispatchProps, InternalLayoutOwnProps } from 'components/features/pfm/InternalLayout/InternalLayout'
import { isMobileOrTabletSelector } from 'selectors/viewportSelectors'

const mapStateToProps = (state: State): InternalLayoutStateProps => ({
  isMenuShown: state.app.sidebar.shownPane !== null,
  isNotificationsExpanded: state.app.notifications.isExpanded,
  isMobileOrTablet: isMobileOrTabletSelector(state),
})

const InternalLayoutContainer = connect<
  InternalLayoutStateProps,
  InternalLayoutDispatchProps,
  InternalLayoutOwnProps
>(mapStateToProps)(InternalLayout)

export default InternalLayoutContainer
